import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-point-up': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M105.6 83.2V169.4A115.5-115.5 0 0 1 83.2 167.2C35.3 167.2 0 202.3 0 259.2 0 304.5 48.5 316.2 78.8 334.9 91.2 342.6 102.1 351.9 112 360.8L112.2 360.9 112.3 361C129.8 376.3 136 384.2 136 391.2V393.9C131 399.6 128 407.4 128 416V480C128 497.7 140.9 512 156.8 512H387.2C403.1 512 416 497.7 416 480V416C416 407.4 413 399.6 408 393.9V391.2C408 362.5 448 324.1 448 264V242.7C448 180.2 409.3 143.9 356.9 142.8 339 130.3 316.1 124.3 294.1 126.8A93.1-93.1 0 0 1 272 118.8V83.2C272 37.8 234.4 0 188.8 0 143.7 0 105.6 38.1 105.6 83.2zM224 83.2V174.2C238.7 161.4 266.8 159.8 285.1 179.2 304.7 167.9 330.7 177.5 338.7 192.1 377.8 185.6 400 202.2 400 242.7V264C400 309.5 364.1 341.2 360.3 384H183.6C180.6 358.8 162.3 341 144 324.9 131.3 313.6 118.7 303.2 104.1 294.1 80.7 279.6 48 268 48 259.2 48 235.8 56.8 215.2 83.2 215.2 118.4 215.2 136.3 241.6 153.6 241.6V83.2C153.6 64.8 170.1 48 188.8 48 207.8 48 224 64.2 224 83.2zM352 424C365.3 424 376 434.7 376 448S365.3 472 352 472 328 461.3 328 448 338.7 424 352 424z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-point-up.js
// module id = DnVZ
// module chunks = 144